import { MeetingRoom } from "@mui/icons-material";
import ViewCad from "../../../config/view";
import { medicoController } from "../../medico/medico.controller";
import { salaController } from "../../sala/sala.controller";
import { atendimentoController } from "../atendimento.controller";
import { Atendimento, AtendimentoActions, AtendimentoState } from "../atendimento.model";
import { useEffect } from "react";
import { connect } from "react-redux";
import { MedicoActions, MedicoState } from "../../medico/medico.model";
import { SalaActions, SalaState } from "../../sala/sala.model";
import { ApplicationState } from "../../../store";
import { bindActionCreators, Dispatch } from "redux";
import { Box, Divider, Typography } from "@mui/material";
import { StripedDataGrid } from "../../../components/select";
import { GridColDef } from "@mui/x-data-grid";
import { formatData } from "../../../services/utils";


export interface AtendimentoCadViewProps {
    atendimentoState: AtendimentoState
    atendimentoActions: AtendimentoActions
    medicoState: MedicoState
    medicoActions: MedicoActions
    salaState: SalaState
    salaActions: SalaActions
}

const columnsAtendimento: GridColDef[] = [
    { field: 'medico', headerName: 'Medico', flex: 8, valueGetter: (value, row: Atendimento) => row.medico.nome },
    { field: 'sala_atendimento', headerName: 'Sala', flex: 4, valueGetter: (value, row: Atendimento) => row.sala_atendimento?.descricao },
]


function AtendimentoCadastro(props: AtendimentoCadViewProps) {
    const { atendimentoActions, atendimentoState } = props
    const { error, loading, loadingRows, msg, row, rows, showAlert, showDialogExluir, status } = atendimentoState
    const { create, read, update, deletar, set, get, setShowAlert, setShowDialogExluir, setClearValue, abrirNovoAtendimento, continuarAtendimento } = atendimentoActions

    console.log("chamou AtendimentoCadastro")
    /*     useEffect(()=>{
            console.log("chamou useEffect AtendimentoCadastro")
            if(props.medicoState.rows.length === 0)
                props.medicoActions.read()
            if(props.salaState.rows.length === 0)
                props.salaActions.read()
        },[]) */

    const handleExcluir = (row: Atendimento) => {
        deletar(row);
        setShowDialogExluir(false);
    }

    const formValidate = (values: Atendimento) => {
        const errors: any = { medico: {}, sala_atendimento: {} }
        if (!values.medico._id)
            errors.medico._id = "Informe o médico que estará atendendo."
        if (!values.sala_atendimento?._id)
            errors.sala_atendimento._id = "Informe a sala do atendimento."

        return errors
    }

    const handleUpdate = (value: Atendimento) => {
        if (!value._rev) {
            abrirNovoAtendimento({ medico: value.medico, sala: value.sala_atendimento! });
        } else {
            continuarAtendimento(value);
        }
    }

    var viewCad = new ViewCad({
        formTitle: "Sessão de atendimento",
        formFieldDescription: "sala_atendimento.descricao",
        formSubtitle: "Informe os dados a baixo para iniciar as chamadas",
        loading: loading,
        msg: msg,
        row: row,
        status: status,
        showAlert: showAlert,
        showDialogExluir: showDialogExluir,
        buttonNovo: {
            show: false,
            title: "",
            onClick: () => { },
        },
        handleExcluir: handleExcluir,
        formValidate: formValidate,
        handleUpdate: handleUpdate,
        handleCloseAlert: () => setShowAlert(false),
        setShowDialogExluir: setShowDialogExluir,
        contentForm: [
            {
                fieldName: "medico", label: "Médico", type: "autocomplete", labelAutocomplete: "nome", key: "nome",
                colunsXS: 12, colunsSM: 12, colunsMD: 12, require: true, list: medicoController.state.rows
            },
            {
                fieldName: "sala_atendimento", label: "Sala de atendimento", type: "autocomplete", labelAutocomplete: "descricao", key: "descricao",
                colunsXS: 12, colunsSM: 12, colunsMD: 12, require: true, list: salaController.state.rows
            },

        ],
        buttonActions: [
            { label: "Iniciar Atendimento", color: "primary", variant: "contained", icon: <MeetingRoom />, handleOnClick: handleUpdate }
        ],
        ContentBox: (props) => {
            if (rows.length > 0)
                return (
                    <Box sx={{ mt: 5, display: "flex", flex: 1, flexDirection: "column" }}>
                        <Divider />
                        <Typography variant="subtitle1">Sessões de atendimento abertas: {formatData(new Date().toISOString())}</Typography>
                        <StripedDataGrid
                            disableRowSelectionOnClick
                            rows={rows}
                            columns={columnsAtendimento}
                            getRowId={row => row._id}
                            density={'compact'}
                            style={{ fontSize: '0.875rem' }}
                            hideFooterPagination={true}
                            hideFooter={true}
                            filterMode="client"
                            loading={loadingRows}
                            onRowClick={ev => {
                                console.log("dataGrid click", ev)
                                set(ev.row)
                            }}
                        />
                    </Box>
                )
            return <div></div>
        }
    })

    return viewCad.render()
}


export const mapStateToAtendimentoCadProps = (state: ApplicationState) => ({
    atendimentoState: state.atendimentoState,
    salaState: state.salaState,
    medicoState: state.medicoState,
})

export const mapDispatchToAtendimentoCadProps = (dispatch: Dispatch) => ({
    atendimentoActions: bindActionCreators({ ...atendimentoController.reducer.actions }, dispatch),
    salaActions: bindActionCreators({ ...salaController.reducer.actions }, dispatch),
    medicoActions: bindActionCreators({ ...medicoController.reducer.actions }, dispatch),
})


export default connect(mapStateToAtendimentoCadProps, mapDispatchToAtendimentoCadProps)(AtendimentoCadastro)

